import React, { useEffect, useCallback } from 'react';
import styled from 'styled-components';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import { ascCtaInteraction } from 'helpers/src/gtag';
import Times from 'icons/src/Times';
import Button from './button/index';
import Content from './content';

const ModalComponent = ({
  className,
  open,
  onCloseModal,
  onOpenModal,
  title,
  content,
  children,
  openAfterSeconds,
  ...props
}) => {
  const ms = parseFloat(openAfterSeconds * 1000);

  useEffect(() => {
    if (Number.isNaN(ms)) {
      return undefined;
    }
    if (!onOpenModal) {
      console.warn('core Modal did not receive an onOpenModal function.');
      return undefined;
    }
    const timer = setTimeout(() => {
      onOpenModal(true);
    }, ms);
    return () => clearTimeout(timer);
  }, [
    onOpenModal,
    ms,
  ]);

  const onClose = useCallback(() => {
    ascCtaInteraction({
      element_text: 'onClose modal',
      element_type: 'popup',
      event_action_result: 'close',
    });
    if (onCloseModal) {
      onCloseModal();
    }
  }, [onCloseModal]);

  return (
    <Modal
      className={className}
      open={open}
      onClose={onClose}
      center
      showCloseIcon={false}
      {...props}
    >
      <Header $hasTitle={Boolean(title)}>
        {title && (
          <Title>{title}</Title>
        )}
        <StyledButton
          aria-label="Modal sluiten"
          onClick={onCloseModal}
          eventActionResult="close"
        >
          <Times />
        </StyledButton>
      </Header>
      <Flex>
        {content && <Content $content={content} />}
        {children && (
          <Content>
            {children}
          </Content>
        )}
      </Flex>
    </Modal>
  );
};

const Title = styled.span`
  font-size: 1.2rem;
  font-weight: bold;
`;

const StyledButton = styled(Button).attrs({ wrapper: true })`
  svg {
    color: black;
    width: 1rem;
    height: 2rem;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: ${({ $hasTitle }) => ($hasTitle ? 'space-between' : 'flex-end')};
  align-items: center;
  padding-bottom: .75rem;
  margin-bottom: .75rem;
  border-bottom: 1px solid ${({ theme }) => theme.grayLightColor};
`;

const Flex = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export default styled(ModalComponent)``;
